import { Lightning } from '@lightningjs/sdk'

export default class BrandButton extends Lightning.Component {
  static _template() {
    return {
      w: 172,
      h: 172,
      flexItem: {},
      Wrapper: {
        mount: 0.5,
        x: w => w / 2,
        y: h => h / 2,
        w: 132,
        h: 132,
        rect: true,
        color: 0xffffffff,
        texture: Lightning.Tools.getRoundRect(132, 132, 24),
        Image: {
          w: w => w,
          h: h => h,
        },
        zIndex: 2,
      },
      Shadow: {
        mount: 0.5,
        x: w => w / 2,
        y: h => h / 2,
        texture: Lightning.Tools.getShadowRect(132, 132, 24, 24),
        color: 0xff4a4a4a,
        zIndex: 1,
      },
    }
  }

  _init() {
    this.tag('Image').patch({ src: this.item.image })
  }

  _focus() {
    this.patch({
      Wrapper: {
        smooth: {
          w: 172,
          h: 172,
        },
      },
      Shadow: {
        smooth: {
          scale: 1.3,
        },
      },
    })
  }
  _unfocus() {
    this.patch({
      Wrapper: {
        smooth: {
          w: 132,
          h: 132,
        },
      },
      Shadow: {
        smooth: {
          scale: 1,
        },
      },
    })
  }
}
